var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.enabled !== false)?_c('div',{class:{
    section: true,
    'section-parking': true,
    'section-parking-v2': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.data.title)?_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.$tdb(_vm.data.title),"subtitle":_vm.$tdb(_vm.data.subtitle)}})],1):_vm._e(),_vm._v(" "),_c('OrganismsCommonOrganismParkingAccessV2',{attrs:{"parking-access":_vm.data.items}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }